import { render, staticRenderFns } from "./HeaderMenuColumn.vue?vue&type=template&id=e536d8ec&"
import script from "./HeaderMenuColumn.vue?vue&type=script&lang=js&"
export * from "./HeaderMenuColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e536d8ec')) {
      api.createRecord('e536d8ec', component.options)
    } else {
      api.reload('e536d8ec', component.options)
    }
    module.hot.accept("./HeaderMenuColumn.vue?vue&type=template&id=e536d8ec&", function () {
      api.rerender('e536d8ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/menu/HeaderMenuColumn.vue"
export default component.exports